import { DeepPartial } from 'react-hook-form';
import { FormValues } from '@graphql/index';
import { applicationFormInitialState } from './appInitialState';
import createContextWithSelector from './createContextWithSelector';

const {
  Provider: AppProvider,
  useSetStore: useSetApplicationData,
  useStore,
} = createContextWithSelector<DeepPartial<FormValues>>(applicationFormInitialState);

type Key = keyof FormValues;

const useApplicationData = <
  T extends Key | Key[] | undefined,
  R = T extends Key[] ? { [K in Key]?: FormValues[K] } : T extends Key ? Partial<FormValues>[T] : Partial<FormValues>,
>(
  key?: T,
): R => {
  if (Array.isArray(key)) {
    return key.reduce((acc, k) => {
      const state = useStore(store => store[k as keyof FormValues]);
      return { ...acc, [k]: state };
    }, {} as R);
  } else if (key !== undefined) {
    return useStore(store => store[key as Key]) as R;
  } else {
    const state = useStore(store => store);
    return state as R;
  }
};

export { AppProvider, createContextWithSelector, useApplicationData, useSetApplicationData };
